import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function ChatPortal({ children }) {
  const [el] = useState(() => document.createElement("div"));
  useEffect(() => {
    el.setAttribute("data-chat-portal", "");
    document.body.appendChild(el);
    return () => document.body.removeChild(el);
  }, [el]);
  return createPortal(children, el);
}
